<template>
  <vue-modal
    name="termsConditionModal"
    :pivotY="0.15"
    :width="widthModal"
    :height="heightModal"
    :scrollable="true"
    :classes="['generic-modals', 'v--modal']"
    ref="vueTermsConditionModal"
    @opened="setInitialData"
    @closed="closed"
  >
    <section class="ugc-terms-conditions-modal">
      <h2 class="terms-text">{{ translations.termsConditionHeader }}</h2>
      <div class="ugc-terms-conditions-modal-wrapper">
        <div class="ugc-terms-conditions-modal-wrapper-content">
          <div class="ugc-terms-conditions-modal-wrapper-content-text row">
            <strong>{{ translations.termsConditionTrades1 }}</strong
            ><span class="main-text">{{ translations.termsConditionTrades2 }}</span>
          </div>
          <div class="ugc-terms-conditions-modal-wrapper-content-list row">
            <div class="small-12 medium-6 large-6 columns">
              <ul class="ugc-terms-list check">
                <li>
                  <strong>{{ translations.termsConditionList1 }}</strong
                  ><span class="main-text">{{
                    translations.termsConditionListDesc1
                  }}</span>
                </li>
                <li>
                  <strong>{{ translations.termsConditionList2 }}</strong
                  ><span class="main-text">{{
                    translations.termsConditionListDesc2
                  }}</span>
                </li>
                <li>
                  <strong>{{ translations.termsConditionList3 }}</strong
                  ><span class="main-text">{{
                    translations.termsConditionListDesc3
                  }}</span>
                </li>
                <li>
                  <span class="main-text">{{ translations.termsConditionList4 }}</span>
                </li>
              </ul>
            </div>
            <div class="small-12 medium-6 large-6 columns">
              <ul class="ugc-terms-list x">
                <li>
                  <strong>{{ translations.termsConditionList5 }}</strong>
                </li>
                <li>
                  <strong>{{ translations.termsConditionList6 }}</strong>
                </li>
                <li>
                  <strong>{{ translations.termsConditionList7 }}</strong>
                </li>
                <li>
                  <strong>{{ translations.termsConditionList8 }}</strong>
                </li>
                <li>
                  <strong>{{ translations.termsConditionList9 }}</strong>
                </li>
                <li>
                  <strong>{{ translations.termsConditionList10 }}</strong>
                </li>
                <li>
                  <strong>{{ translations.termsConditionList11 }}</strong>
                </li>
                <li>
                  <strong>{{ translations.termsConditionList12 }}</strong>
                </li>
                <li v-show="validateText('termsConditionList13')">
                  <strong>{{ translations.termsConditionList13 }}</strong>
                </li>
                <li v-show="validateText('termsConditionList14')">
                  <strong>{{ translations.termsConditionList14 }}</strong>
                </li>
                <li v-show="validateText('termsConditionList15')">
                  <strong>{{ translations.termsConditionList15 }}</strong>
                </li>
                <li v-show="validateText('termsConditionList16')">
                  <strong>{{ translations.termsConditionList16 }}</strong>
                </li>
                <li v-show="validateText('termsConditionList17')">
                  <strong>{{ translations.termsConditionList17 }}</strong>
                </li>
              </ul>
            </div>
          </div>
          <div class="ugc-terms-conditions-modal-wrapper-content-rights row">
            <div class="small-12">
              <p class="vans-reserve">
                <strong>{{ translations.termsConditionReserve }}</strong>
              </p>
              <p class="all-customs">{{ translations.termsConditionCustoms }}</p>
            </div>
          </div>
        </div>
        <contact-form
          v-if="configuration.ugc.enableUGCContactDetails"
          report-field-blur
          @validity-update="updateContactFormValidity"
          @field-blur-event="resetScreenScrollPosition"
          @contact-details-update="contactDetailsUpdated"
        ></contact-form>
        <div class="ugc-terms-conditions-modal-wrapper-cta row">
          <div class="small-12">
            <label for="add-your-own-check">
              <input
                type="checkbox"
                :disabled="!enableIAgreeCheckbox || !!this.$cookies.get(sessionKeys.ugcTermsConditionsAccepted)"
                :checked="hasAcceptedTerms"
                class="add-your-own-check"
                @change="setCookie($event)"
              />
              <span class="custom radio">{{ translations.termsConditionCheck }}</span>
            </label>

            <label for="newsletter-check" v-if="configuration.locale==='en_us' && configuration.enableOptInCheckbox">
              <input
                type="checkbox"
                class="newsletter-check"
                :checked="(configuration.forceCheckedOptIn && !this.$cookies.get(sessionKeys.ugcOptIn)) || this.$cookies.get(sessionKeys.ugcOptIn)"
                @change="setOptInCookie($event)"
              />
              <span class="custom radio">{{ translations.twoStepsTermsConditionModalTermsOptIn }}</span>
            </label>

            <ugc-image-upload
              ref="imageUpload"
              @click="setDataLayer"
              :disable-button="!enableChooseImageButton"
              inputLabel="termsConditionChooseImage"
              :forceUpload="hasAcceptedTerms"
            />
            <p class="moderation-message">
             {{ translations.ugcEPTermsCondReviewExtra }}
             <a target="blank" :href="translations.ugcEPTermsCondContactLink">{{ translations.ugcEPTermsCondReviewContant }}</a>
            </p>
            <p>
              <a
                :href="translations.termsConditionLink"
                target="_blank"
                class="conditions"
              >
                {{ translations.termsConditionLinkText }}
              </a>
            </p>
          </div>
        </div>
        <div slot="top-right">
          <button
            class="close-button"
            title="Close"
            @click="$modal.hide('termsConditionModal')"
          >
            <span class="icon-close"></span>
          </button>
        </div>
      </div>
    </section>
  </vue-modal>
</template>

<script>
import contactForm from '@/components/ContactForm';
import ugcImageUpload from '@/components/UGC/Tray/ImageUpload';

import { sessionKeys } from '@/data/constants';

export default {
  name: "terms-condition-modal",
  components: {
    contactForm,
    ugcImageUpload
  },
  data() {
    return {
      sessionKeys,
      hasAcceptedTerms: false,
      termsAssetSizeText: "",
      isContactFormValid: false,
      widthModal: "75%",
      heightModal: "auto",
    };
  },
  computed: {
    translations() {
      return this.$store.state.translations.data;
    },
    pdm() {
      return this.$store.state.utils.pdm;
    },
    configuration() {
      return this.$store.state.utils.configuration;
    },
    enableIAgreeCheckbox() {
      return this.isContactFormValid || !this.configuration.ugc.enableUGCContactDetails;
    },
    enableChooseImageButton() {
      return this.enableIAgreeCheckbox && this.hasAcceptedTerms;
    },
    isMobile() {
      return this.$store.getters["utils/returnScreenSize"].includes('mobile');
    },
  },
  methods: {
    /**
     * @function resetScreenScrollPosition
     * Triggers the screen size calculations at Customizer.vue after the mobile keyboard is closed
     */
    resetScreenScrollPosition() {
      if (this.isMobile) this.$eventBus.$emit('recalculate-customizer-screen-size');
    },
    closed() {
      if (this.configuration.ugc.forceUgcTermConditions) {
        this.$eventBus.$emit("show-image-upload-button", false);
      }
      this.resetScreenScrollPosition();
    },
    /**
     * @function setInitialData
     * Resets the data attributes used to control the state.
     */
    setInitialData() {
      this.hasAcceptedTerms = !!this.$cookies.get(this.sessionKeys.ugcTermsConditionsAccepted);
      this.isContactFormValid = !!this.$cookies.get(this.sessionKeys.ugcContactDetailsFilled);
      if (this.isContactFormValid) {
        this.contactDetailsUpdated(this.$cookies.get(this.sessionKeys.ugcContactDetailsFilled));
      }

      if(this.hasAcceptedTerms) this.setCookie();
    },
    /**
     * Set cookie variable for term and condition modal
     * @public
     */
    setCookie(event) {
      const isTCAccepted = !!this.$cookies.get(this.sessionKeys.ugcTermsConditionsAccepted);
      this.hasAcceptedTerms = isTCAccepted ? isTCAccepted : event ? event.target.checked : false;
      this.$refs['imageUpload'].setTermsConditionAccepted(this.hasAcceptedTerms);
    },
    validateText(key) {
      return this.translations[key] !== "";
    },
    setDataLayer() {
      this.$cookies.set(this.sessionKeys.ugcTermsConditionsAccepted, true, 0);
      if (!this.$store.getters['utils/useEcomDataLayerFormat']) {
        this.$ugcDataLayer.logAnalyticsEvent({ type: this.$ugcDataLayer.types.chooseImage });
      }
    },
    updateContactFormValidity(isValid) {
      this.isContactFormValid = isValid;
    },
    contactDetailsUpdated(contactDetails) {
      this.contactDetails = {
        ...this.contactDetails,
        ...contactDetails
      };
      this.$store.commit('UGCEntryPoint/SET_CONTACT_DETAILS', this.contactDetails);
    },
    setModalDimensions() {
      if (window.innerWidth >= 768) {
        this.widthModal = "75%";
        this.heightModal = "auto";
      } else {
        this.widthModal = "100%";
        this.heightModal = "100%";
      }
    }
  },
  created() {
    this.setModalDimensions();
  }
};
</script>
